export const ERROR_CODES = {
  /** Account is SSO-enabled; password login is not available for it. */
  SSO_REQUIRED: 'SSO_REQUIRED',
  /** Too many failed attempts; the account is in its cooldown window. */
  ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
  /** Credentials were rejected, or the attempt failed for no stated reason. */
  LOGIN_FAILED: 'LOGIN_FAILED',
  /** Signup could not be completed, for no reason the user can act on. */
  SIGNUP_FAILED: 'SIGNUP_FAILED',
  /**
   * The email already has an account. Distinct from `SIGNUP_FAILED` because
   * the client offers routes out of it: logging in, and resetting the password.
   */
  ACCOUNT_EXISTS: 'ACCOUNT_EXISTS',
  /** The email's domain is SSO-managed; finish signup at the URL supplied. */
  SSO_REDIRECT_REQUIRED: 'SSO_REDIRECT_REQUIRED',
  /** The v3 score was too low, or v3 never loaded: solve the v2 checkbox. */
  CAPTCHA_CHALLENGE_REQUIRED: 'CAPTCHA_CHALLENGE_REQUIRED',
  /**
   * The email's domain is on the participant blocklist (relay and forwarding
   * services such as duck.com). The user can recover by using another address.
   */
  EMAIL_DOMAIN_NOT_ALLOWED: 'EMAIL_DOMAIN_NOT_ALLOWED',
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];

export function isErrorCode(value: unknown): value is ErrorCode {
  return (
    typeof value === 'string' &&
    Object.values(ERROR_CODES).includes(value as ErrorCode)
  );
}
